import React, { useState } from 'react'
import * as NUMBER from 'constant/number'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Card, Modal } from 'antd'
import formatArticle from 'helper/format-input-fields'
import { createAttachment, getArticleAttachments } from 'action/article'
import AttachmentTable from 'view/page/dataset-management/component/attachments/table'
import NewAttachment from 'view/page/dataset-management/component/attachments/new-attachment'
import styles from './styles.scss'

const Attachments = ({ attachments, dataset, createAttachment, getArticleAttachments, loadingAttachments }) => {
  const [visible, setVisible] = useState(false)
  const handleClick = () => {
    setVisible(true)
    getArticleAttachments(dataset.uuid)
  }
  const presets = formatArticle(dataset)
  return (
    <>
      <a onClick={handleClick}>Attachments</a>
      <Modal
        bodyStyle={{
          backgroundColor: '#F7F7F7'
        }}
        closable={true}
        confirmLoading={loadingAttachments}
        footer={null}
        maskClosable={true}
        onCancel={() => {
          setVisible(false)
        }}
        title='Attachments'
        visible={visible}
        width={NUMBER.EIGHTEEN_HUNDRED}
      >
        {getModalContent(presets)}
      </Modal>

    </>
  )
}

const getModalContent = (presets) => (
  <Card
    className={styles.attachment_card}
    title={
      <span className={styles.card_header}>
        <h3>{presets.title}</h3>
        <div className={styles.group_right}>
          <NewAttachment dataset={presets} />
        </div>
      </span>
    }
  >
    <AttachmentTable dataset={presets} />
  </Card>
)

Attachments.propTypes = {
  attachments: PropTypes.object,
  createAttachment: PropTypes.func,
  dataset: PropTypes.object,
  getArticleAttachments: PropTypes.func,
  loadingAttachments: PropTypes.bool
}

const mapStateToProps = (state) => ({
  attachments: state.article.attachments,
  loadingAttachments: state.article.loadingAttachments
})

const mapDispatchToProps = (dispatch) => ({
  addDatasetAttachment: bindActionCreators(createAttachment, dispatch),
  getArticleAttachments: bindActionCreators(getArticleAttachments, dispatch)
})
export default connect(mapStateToProps, mapDispatchToProps)(Attachments)
